import { ChangeRoutePayload, InAppNotification, ROLES_KEYS, User } from '@interfaces';

export type CandidateVerificationTab = 'result' | 'basic-details' | 'form-verification';

const candidateVerificationCvmRoles = [
  ROLES_KEYS.Admin,
  ROLES_KEYS.Team_Leader,
  ROLES_KEYS.Employee,
  ROLES_KEYS.Field_Consultant,
  ROLES_KEYS.Employer,
];

export const getCandidateVerificationRoute = (
  notification: InAppNotification,
  myself: Partial<User>,
  tab?: CandidateVerificationTab | null
): ChangeRoutePayload | null => {
  if (!notification.relatedCandidateVerificationId) {
    return null;
  }

  if (candidateVerificationCvmRoles.includes(myself.role?.key as ROLES_KEYS)) {
    return {
      linkParams: ['cvm', 'cv-list'],
      extras: {
        queryParams: {
          verificationId: notification.relatedCandidateVerificationId,
          ...(tab ? { tab } : {}),
        },
      },
    };
  }

  return null;
};
